module.exports = function(bootstrap) {
	bootstrap.directive('smartStack', ["$window", "$compile", function($window, $compile) {
		return {
			transclude: true,
			link: function(scope, element, iAttrs, controller, transclude) { // Linking function is the proper place to modify DOM elements, or attach events
				var list = [];
				var cols = [];
				var config = angular.extend({mobile: 1, tablet: 2, notebook: 2, desktop: 1}, scope.$eval(iAttrs.smartStack));
				var colCount = 1;
				for (var i in config) {
					colCount = Math.max(colCount, config[i]);
				}
				element.empty();
				element.addClass('smartStack');
				for (var x = 0; x < colCount; x++) {
					cols[x] = $('<div class="smartStackColumn' + (x === 0 ? ' firstColumn' : (x === colCount - 1 ? ' lastColumn' : '')) + '"></div>');
					element.append(cols[x]);
				}
				var holderDiv = $('<div></div>');
				element.append(holderDiv);

				transclude(function(clone, innerScope) { // Transclude function, allows us to avoid usin ng-transclude which would add at least 1 extra <div> that we don't want.
					$('<article></article>').append(clone).contents().each(function(i,v) {
						if (v.nodeType !== 3) { // If node is not a text node... we want to skip whitespace
							v = $compile(angular.element(v).clone())(scope);
							list.push(v);
						}
					});
				});
				var alreadyDesktop, alreadyNotebook, alreadyTablet, alreadyMobile;
				var reset = function() {
					list.forEach(function(v,i) {
						holderDiv.append(v);
					});
					// Ensure each div column is empty.  Necessary because angular was ghosting copies of the elements if they were added during linking by our first call to resize()
					cols.forEach(function(v,i) {
						v.empty();
						v.css({display: 'block'});
					});
				};
				var resize = function() {
					var ww = $window.innerWidth || $($window).width();
					if (ww > 1243 && !alreadyDesktop) {
						alreadyNotebook = alreadyTablet = alreadyMobile = false;
						alreadyDesktop = true;
						reset();
						list.forEach(function(v,i) {
							cols[i%config.desktop].append(v);
							cols[i%config.desktop].css({width: 100/config.desktop + '%', display: config.desktop == 1 ? 'block' : 'inline-block'});
						});
					}
					else if (ww <= 1243 && ww > 935 && !alreadyNotebook) {
						alreadyDesktop = alreadyTablet = alreadyMobile = false;
						alreadyNotebook = true;
						reset();
						list.forEach(function(v,i) {
							cols[i%config.notebook].append(v);
							cols[i%config.notebook].css({width: 100/config.notebook + '%', display: config.notebook == 1 ? 'block' : 'inline-block'});
						});
					}
					else if (ww <= 935 && ww > 627 && !alreadyTablet) {
						alreadyDesktop = alreadyNotebook = alreadyMobile = false;
						alreadyTablet = true;
						reset();
						list.forEach(function(v,i) {
							cols[i%config.tablet].append(v);
							cols[i%config.tablet].css({width: 100/config.tablet + '%', display: config.tablet == 1 ? 'block' : 'inline-block'});
						});
					}
					else if (ww <= 627 && !alreadyMobile) {
						alreadyDesktop = alreadyNotebook = alreadyTablet = false;
						alreadyMobile = true;
						reset();
						list.forEach(function(v,i) {
							cols[i%config.mobile].append(v);
							cols[i%config.mobile].css({width: 100/config.mobile + '%', display: config.mobile == 1 ? 'block' : 'inline-block'});
						});
					}
				};
				resize();
				angular.element($window).on('resize', function() { resize(); scope.$apply(); });
			}
		}
	}]);
}